import {
	Box,
	Container,
	Divider,
	LinearProgress, makeStyles,
	Typography
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';
import { useActions, useValues } from 'kea';

import userlogic from 'src/store/user';
import rolelogic from 'src/store/role';
import grouplogic from 'src/store/group';

import Page from 'src/components/Page';
import AddDialog from './AddDialog';
import UserTable from './UserTable';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	}
}));

const Users = () => {
	const classes = useStyles();

	const { users } = useValues(userlogic);
	const { fetchAll: userFetchAll } = useActions(userlogic);

	const { roles } = useValues(rolelogic);
	const { fetch: roleFetch } = useActions(rolelogic);

	const { groups } = useValues(grouplogic);
	const { fetchAll: groupFetchAll } = useActions(grouplogic);

	useEffect(() => {
		users ?? userFetchAll();
		roles ?? roleFetch();
		groups ?? groupFetchAll();
	}, []);// eslint-disable-line

	return (
		<Page
			className={classes.root}
			title="Users"
		>
			{
				roles === null || users === null ?
					< ></>
					:
					<Container maxWidth={false} style={{ paddingBottom: 20 }}>
						<Box mt={3} >
							<Typography variant="h3" gutterBottom>
								User Management
							</Typography>
							<Divider />
						</Box>
						<AddDialog all_roles={roles} />
						{/* <Toolbar /> */}
						<Box mt={3}>
							<Grid container spacing={1}>
								<UserTable />
							</Grid>
						</Box>
					</Container>
			}
		</Page>
	);
};

export default Users;
